import {FormComponent} from '@ngx-ivengi/crud';
import {OnInit} from '@angular/core';

export class CombiFormComponent extends FormComponent implements OnInit {
  public blockClasses: string;
  public formClass: string;
  public formContainerClass: string;
  public formLabelClass: string;
  public formControlClass: string;

  public ngOnInit() {
    super.ngOnInit();

    switch(this.formMode) {
      case this.FormMode.ADD : {
        this.blockClasses = 'col-xs-12';
        this.formClass = 'form-horizontal';
        this.formContainerClass = 'col-xs-12 col-lg-6';
        this.formLabelClass = 'col-sm-4';
        this.formControlClass = 'col-sm-8';
      } break;

      case this.FormMode.UPDATE : {
        this.blockClasses = 'col-xs-12 col-md-4';
        this.formClass = '';
        this.formContainerClass = 'col-xs-12';
        this.formLabelClass = '';
        this.formControlClass = '';
      } break;
    }
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/shared/combi-form.component.ts